import { render, staticRenderFns } from "./TransactionDetails.vue?vue&type=template&id=c3357568&scoped=true"
import script from "./TransactionDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionDetails.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TransactionDetails.vue?vue&type=style&index=0&id=c3357568&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3357568",
  null
  
)

export default component.exports